import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";
import { CgMail } from "react-icons/cg";
import { IoIosCall } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import "./products.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

const Products = () => {

   const scrollConfig = {
        trigger: ".products-gsap",
        start: "top 80%",
        end: "top 70%",
        scrub: 1,
      }
      useGSAP(() => {
    const tl4 = gsap.timeline()
    tl4.from(".products-heading", {
      y: -100,
      opacity: 0,
      duration: 1,
      scrollTrigger:scrollConfig
    });
  });

  const [loader, setLoader] = useState(true);
  const [contactIds, setContactIds] = useState([]);


  // Api call code

  const [data, setData] = useState([]);

const getApi = () => {
  axios
    .get("https://bestdealelectricalsbackend.onrender.com/bestdealelectricals/products ")
    .then((res) => {
      setData(res.data.Products);
      setLoader(false);
    })
    .catch((err) => {
      console.error("API Error:", err);
    });
  };
useEffect(()=>{getApi()},[])

   const navigate = useNavigate();
  const NaviagteDetail = (id) => {
    navigate(`/detailPage/${id}`);
  };

  const ActiveContact = (id) => {
    setContactIds((prev) => [...prev, id]);
  };


 const DeactiveContact = (id) => {
  const updatedList = contactIds.filter((itemId) => itemId !== id);
  setContactIds(updatedList);
};
   useEffect(()=>{
   if(data.length>0){
    setLoader(false)
  }
  
 },[data])
  return (
    <>
      <section className="py-5 products products-gsap">
        <div className="container">
          <div className="position-relative heading-container mx-auto ">
            <h2 className="heading products-heading">
              P<span className="heading-span">RODUCTS</span>{" "}
            </h2>
            <div className="line products-line"></div>
          </div>

          {loader ? (
            <div className="loader"></div>
          ) : (
            <>
              <div className="row ">
                {data?.map((items, index) => {
                  if (contactIds.includes(items._id)) {
                    return (
                      
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-3" key={items._id}>
                          <div
                            className=" products-container h-100 d-flex flex-column "
                           
                          >
                         
                            <div
                              className="image-container"
                              onClick={() => NaviagteDetail(items._id)}
                            >
                              <img
                                src={items.image}
                                className="w-100  products-img rounded-top"
                                alt={items.title}
                              />
                            </div>
                            <div className="p-3 contact-container  contact-icon">
                            <div className="cross" onClick={()=>{DeactiveContact(items._id)}}>
<RxCross2 className="h3"/>
                            </div>
                              <div className="">
                                <ul className="d-flex icons-ul gap-3 justify-content-center align-items-center ">
                                  <a
                                    href="tel:+919779096815 "
                                    target="_blank"
                                    className=""
                                  >
                                    {" "}
                                    <li className="call">
                                      <IoIosCall />
                                    </li>
                                  </a>
                                  <a
                                    href="mailto:bestdealelectricals4444@gmail.com "
                                    target="_blank"
                                    className=""
                                  >
                                    {" "}
                                    <li className="mail">
                                      <CgMail />
                                    </li>
                                  </a>
                                  <a
                                    href="https://wa.me/919779096815"
                                    target="_blank"
                                  >
                                    {" "}
                                    <li className="whatsapp">
                                      <FaWhatsapp />
                                    </li>
                                  </a>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                     
                    );
                  }
                  return (
                  
                      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-3" key={items._id}>
                        <div
                          className=" products-container  h-100 d-flex flex-column"
                          
                        >
                      
                          <div
                            className="image-container"
                            onClick={() => NaviagteDetail(items._id)}
                          >
                            <img
                              src={items.image}
                              className="w-100 products-img  rounded-top"
                              alt={items.title}
                            />
                          </div>
                          <div className="p-3">
                            <div className="">
                              <div className="title title fw-bold h-100 mb-2">
                               {items.title?.length > 25
  ? items.title.slice(0, 25) + "..."
  : items.title}

                              </div>
                              <div className="title" id="brand">
                                Brand :{" "}
                                <span className="brand fw-normal">
                                  {items.brand}
                                </span>
                              </div>
                              <div className="mt-3 d-flex justify-content-left">
                                <button
                                  className="button py-1 px-3"
                                  onClick={() => ActiveContact(items._id)}
                                >
                                  Contact
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                   
                  );
                })}
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};
export default Products;
